import React from 'react';
import { Button } from 'reactstrap';

interface PropTypes {
  handleSignOut: () => void;
  isFormValid: string | boolean;
}

export function InvitationButtons(props: PropTypes) {
  return (
    <div className='d-flex justify-content-center gap-3'>
      <Button color='danger' onClick={() => props.handleSignOut()} size={'md'}>
        Cancel
      </Button>
      <Button
        color='primary'
        type='submit'
        size={'md'}
        disabled={!props.isFormValid}
      >
        Sign Up
      </Button>
    </div>
  );
}
